var map = {
	"./axia/icons/excel.svg": 345226,
	"./boomea/boomea/icons/excel.svg": 653726,
	"./boomea/icons/excel.svg": 316928,
	"./simplifi/icons/excel.svg": 851266
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 12535;
module.exports = webpackAsyncContext;